const hardDeleteEquipmentServices = {
  toastr: 'Deleted inspection'
};

export default hardDeleteEquipmentServices;
